import React, { useEffect, useState, useRef, useContext } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { MdClose } from "react-icons/md";
import { HiMenuAlt2 } from "react-icons/hi";
import { motion } from "framer-motion";
import { FaUser, FaCaretDown, FaShoppingCart } from "react-icons/fa";
import { UserConfigContext } from "../../../context/UserConfigContext";
import { useSelector } from "react-redux";
import { reset } from "../../../constants/olvide";
import { addEvent } from "../../../constants/config";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";

const Header = () => {
  const loggedUserData = JSON.parse(localStorage.getItem("user")) || {};
  const userType = loggedUserData?.data?.empresas?.[0]?.tipo || "";
  const { id_usuario = "", nrocli = "" } = loggedUserData?.data?.cliente || {};
  const { ip = "", dispositivo = "", tipo_dispositivo = "" } = loggedUserData?.data || {};
  
  const products = useSelector((state) => state.orebiReducer.products);
  // console.log(products);
  const [showUser, setShowUser] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [user, setUser] = useState(null);
  const [empresaNombre, setEmpresaNombre] = useState("");
  const [tipo, setTipo] = useState("");
  const [empresaLogo, setEmpresaLogo] = useState("");
  const [VistaMoneda, setVistaMoneda] = useState("");
  const [VistaSimbolo, setVistaSimbolo] = useState("");
  const [Simbolo, setSimbolo] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [MostrarCotizacion, setMostrarCotizacion] = useState("");
  const [showSubMenu, setShowSubMenu] = useState(false);

  const { config1, config2 } = useContext(UserConfigContext);
  const location = useLocation();
  const navigate = useNavigate();
  const refUserMenu = useRef();
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");

  useEffect(() => {
    const fetchUserAndConfig = async () => {
      const loggedUserData = JSON.parse(localStorage.getItem("user"));
      if (loggedUserData?.data?.user) setUser(loggedUserData.data.user);
      if (loggedUserData?.data?.empresas?.[0]?.tipo) setTipo(loggedUserData.data.empresas[0].tipo);

      if (config1?.empresa?.fantasia || config1?.empresa?.nombre) {
        const nombreEmpresa = config1.empresa.fantasia || config1.empresa.nombre;
        setEmpresaNombre(nombreEmpresa);
        document.title = nombreEmpresa;
      }

      if (config2?.vista?.monedaEcommerce) {
        setVistaMoneda(config2.vista.monedaEcommerce.monedaCotizacion || "");
        setVistaSimbolo(config2.vista.monedaEcommerce.monedaDescripcion || "");
        setSimbolo(config2.vista.monedaEcommerce.monedaSimbolo || "");
        setMostrarCotizacion(config2.vista.monedaEcommerce.mostrar_cotizacion || 1);
      }

      if (config1?.empresa?.logo) setEmpresaLogo(config1.empresa.logo);
    };
    fetchUserAndConfig();
  }, [config1, config2]);

  useEffect(() => {
    setShowUser(false);
    setShowMenu(false);
  }, [location.pathname]);

  const handleGoToCart = () => {
   // addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 7, "", "", 1);
    navigate("/cart");
  };

  const handleExternalLink = (urlKey) => {
    const loggedUserData = JSON.parse(localStorage.getItem("user"));
    const url = loggedUserData?.data?.[urlKey];
    setShowUser(false);
    setShowMenu(false);
    if (url) window.open(url, "_blank");
    else alert(`${urlKey} no disponible.`);
  };

  const logoutUser = () => {
    //addEvent(id_usuario, nrocli, ip, dispositivo, tipo_dispositivo, 14, "", "", 1);
    localStorage.clear();
    sessionStorage.clear();
    setUser(null);
    
     // 🔹 Evaluamos la misma lógica que usa ProtectedRoute
     if (config2?.vista?.login === 0) {
      navigate("/"); // o la página principal del sistema sin login
    } else {
      navigate("/signin"); // si requiere login, lo manda a signin
    }
  };

  const handleLogoClick = () => {
    sessionStorage.setItem("verMas", "false");
    navigate("/");
  };

  const handleRecuperarContrasena = async () => {
    if (password1 !== password2) {
      Swal.fire({ icon: "error", title: "Error", text: "Las contraseñas no coinciden." });
      return;
    }

    try {
      const loggedUserData = JSON.parse(localStorage.getItem("user"));
      const mail_usuario = loggedUserData?.data?.user?.email || "";
      const id_empresa = loggedUserData?.data?.user?.idempresavista || "";
      const id_usuario = loggedUserData?.data?.user?.id || "";

      const key = btoa(`${mail_usuario}|${""}|${id_empresa}|${id_usuario}|1`);
      const baseUrl = window.location.href;
      const passwordMD5_1 = CryptoJS.MD5(password1).toString();
      const passwordMD5_2 = CryptoJS.MD5(password2).toString();

      const response = await reset(key, baseUrl, passwordMD5_1, passwordMD5_2);

      if (response.status) {
        Swal.fire({ icon: "success", title: "Recuperación enviada", text: response.message });
        setShowModal(false);
      } else {
        Swal.fire({ icon: "error", title: "Error", text: response.message || "Ocurrió un error." });
      }
    } catch (error) {
      // console.error(error);
      Swal.fire({ icon: "error", title: "Error", text: error.message || "No se pudo procesar la solicitud." });
    }
  };

  return (
    <div className="w-full h-20 bg-white sticky top-0 z-50 border-b-[1px] border-b-gray-200">
      <nav className="h-full px-4 max-w-container mx-auto relative">
        <div className="flex items-center justify-between h-full">
          {/* Logo */}
          <Link to="/" onClick={handleLogoClick} className="flex items-center">
            {empresaLogo && <img src={empresaLogo} alt={`${empresaNombre} logo`} className="w-25 h-10 mr-4" />}
            <h1 className="text-2xl font-bold cursor-pointer">{empresaNombre}</h1>
          </Link>

          {/* Moneda */}
          {VistaSimbolo && VistaMoneda && (
            <NavLink to="/" className="font-normal text-base text-[#008C8C]">
              {VistaMoneda !== 1 ? `Moneda: ${VistaSimbolo} (${Simbolo}). ` : ""}
              {MostrarCotizacion == 1 ? `Cotización: $ ${VistaMoneda}` : ""}
            </NavLink>
          )}

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            {/* Siempre visibles */}
            <NavLink to="/" className="font-normal text-base text-[#767676] hover:font-bold hover:text-[#262626]" onClick={() => sessionStorage.setItem("verMas", "true")}>Productos</NavLink>
            <NavLink to="/Offer" className="font-normal text-base text-[#767676] hover:font-bold hover:text-[#262626]">Ofertas</NavLink>
            <NavLink to="/News" className="font-normal text-base text-[#767676] hover:font-bold hover:text-[#262626]">Novedades</NavLink>

            {/* Usuario con submenú */}
            <div className="relative" ref={refUserMenu}>
              {user ? (
                <div onClick={() => setShowUser(!showUser) } className="flex items-center gap-2 cursor-pointer">
                  <FaUser /> <span>{user.nombre}</span> <FaCaretDown />
                </div>
              ) : (
                <NavLink to="/signin" className="flex items-center gap-2">
                  <FaUser /> Iniciar Sesión
                </NavLink>
              )}

              {showUser && (
                <ul className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-md p-2 flex flex-col gap-2 z-50 showmenu">
                  {tipo !== "u" && (
                    <>
                      <li onClick={() => navigate("configuracion")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Configuración</li>
                      <li onClick={() => handleExternalLink("url_admin")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Admin Ecommerce</li>
                      <li className="relative cursor-pointer hover:bg-gray-100 p-2 rounded-md" onClick={() => setShowSubMenu(!showSubMenu)}>
                        Seguimiento
                        {showSubMenu && (
                          <ul className="absolute left-full top-0 ml-2 w-48 bg-white rounded-md shadow-md flex flex-col gap-2">
                            <li onClick={() => navigate("tracking")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Tracking</li>
                            <li onClick={() => navigate("analisis")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Estadística</li>
                          </ul>
                        )}
                      </li>
                    </>
                  )}
                  <li onClick={() => navigate("/Profile")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Mi Perfil</li>
                  {config2?.vista?.genera_presupuesto === 1 && (
                    // <li
                    //   onClick={() => handleExternalLink("url_presupuestos")}
                    //   className="cursor-pointer hover:bg-gray-100 p-2 rounded-md"
                    // >
                    //   Mis Presupuestos
                    // </li>
                    <li
                      onClick={() => navigate("/mis_presupuestos")}
                      className="cursor-pointer hover:bg-gray-100 p-2 rounded-md"
                    >
                      Mis Presupuestos
                    </li>                    
                  )}
                  {/* <li onClick={() => handleExternalLink("url_pedidos")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Mis Pedidos</li> */}
                  <li onClick={() => navigate("/mis_pedidos")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Mis Pedidos</li>
                  <li onClick={() => navigate("/Favorite")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Mis Favoritos</li>
                  <li onClick={() => navigate("/Notices")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Avisos de Ingresos</li>
                  <li onClick={() => navigate("/Receive")} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Próximos Ingresos</li>
                  <li onClick={() => setShowModal(true)} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Cambiar Contraseña</li>
                  <li onClick={logoutUser} className="cursor-pointer hover:bg-gray-100 p-2 rounded-md">Cerrar Sesión</li>
                </ul>
              )}
            </div>




            {/* Carrito */}
            <button onClick={handleGoToCart} className={`flex items-center justify-center p-2 rounded-full ${products.length > 0 ? "bg-green-700" : "bg-gray-400"}`}>
              <FaShoppingCart className="text-lg text-white" />
              <span className="ml-2 text-sm font-semibold text-white">Carrito</span>
              {products.length > 0 && <span className="ml-1 text-xs font-semibold text-white">({products.length})</span>}
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden flex items-center">
            <HiMenuAlt2 className="text-2xl cursor-pointer" onClick={() => setShowMenu(!showMenu)} />
          </div>
        </div>

        {/* Mobile Menu */}
        {/* Mobile Menu */}
        {showMenu && (
          <motion.div className="fixed top-0 right-0 h-full w-3/4 bg-white z-50 shadow-md p-3">
            <MdClose className="text-2xl cursor-pointer mb-4" onClick={() => setShowMenu(false)} />
            <ul className="mt-2 flex flex-col gap-1">
              {/* Carrito */}
              <NavLink to="/cart">
                <button className={`flex items-center justify-center py-1 px-2 rounded-full text-sm ${products.length > 0 ? "bg-green-700" : "bg-gray-400"}`}>
                  <FaShoppingCart className="text-lg text-white" />
                  <span className="ml-1 text-xs font-semibold text-white">Carrito</span>
                  {products.length > 0 && <span className="ml-1 text-xs font-semibold text-white">({products.length})</span>}
                </button>
              </NavLink>

              {/* Usuario */}
              {user ? (
                <>
                  <li className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md flex items-center gap-1"><FaUser /> {user.nombre}</li>
                  {tipo !== "u" && (
                    <>
                      <li onClick={() => navigate("configuracion")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Configuración</li>
                      <li onClick={() => handleExternalLink("url_admin")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Admin Ecommerce</li>
                      <li onClick={() => navigate("tracking")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Tracking</li>
                      <li onClick={() => navigate("analisis")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Estadística</li>
                    </>
                  )}
                  <li onClick={() => navigate("/Profile")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Mi Perfil</li>
                  {config2?.vista?.genera_presupuesto === 1 && (
                    <li onClick={() => handleExternalLink("url_presupuestos")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Mis Presupuestos</li>
                  )}
                  <li onClick={() => handleExternalLink("url_pedidos")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Mis Pedidos</li>
                  <li onClick={() => navigate("/Favorite")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Mis Favoritos</li>
                  <li onClick={() => navigate("/Notices")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Avisos de Ingresos</li>
                  <li onClick={() => navigate("/Receive")} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Próximos Ingresos</li>
                  <li onClick={() => setShowModal(true)} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Cambiar Contraseña</li>
                  <li onClick={logoutUser} className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md text-sm">Cerrar Sesión</li>
                </>
              ) : (
                <NavLink to="/signin" className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md flex items-center gap-1 text-sm"><FaUser /> Iniciar Sesión</NavLink>
              )}

              {/* Siempre visibles */}
              <NavLink to="/" className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md flex items-center gap-1 text-sm">Productos</NavLink>
              <NavLink to="/Offer" className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md flex items-center gap-1 text-sm">Ofertas</NavLink>
              <NavLink to="/News" className="cursor-pointer hover:bg-gray-100 py-1 px-2 rounded-md flex items-center gap-1 text-sm">Novedades</NavLink>
            </ul>
          </motion.div>
        )}

      </nav>

      {/* Modal Cambiar Contraseña */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md relative">
            <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" onClick={() => setShowModal(false)}><MdClose size={20} /></button>
            <h2 className="text-xl font-bold mb-4">Cambiar Contraseña</h2>
            <div className="mb-4">
              <label htmlFor="new-password" className="block text-sm font-medium text-gray-700 mb-1">Nueva Contraseña</label>
              <input type="password" id="new-password" className="w-full border border-gray-300 rounded px-3 py-2" placeholder="Ingresá la nueva contraseña" value={password1} onChange={(e) => setPassword1(e.target.value)} />
            </div>
            <div className="mb-4">
              <label htmlFor="repeat-password" className="block text-sm font-medium text-gray-700 mb-1">Repetir Contraseña</label>
              <input type="password" id="repeat-password" className="w-full border border-gray-300 rounded px-3 py-2" placeholder="Repetí la contraseña" value={password2} onChange={(e) => setPassword2(e.target.value)} />
            </div>
            <button className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700" onClick={handleRecuperarContrasena}>Confirmar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Header;
